export default "__VITE_ASSET__BQc3dav8__"